<script setup>
import {computed, defineEmits, defineProps, nextTick, onMounted, ref, watch} from "vue";
import {useLocales} from "@/composables/locales";
import * as tempusDominus from "@eonasdan/tempus-dominus";
const {locale} = useLocales()

const props =defineProps({
  id: { type: String, default: 'date-range-picker' },
  currentDate: { type: String, default: null },
})
const date = ref(new Date())
const emits = defineEmits(['update:date'])

const year = computed(() => new Date(props?.currentDate).getFullYear())
const month = computed(() => new Date(props?.currentDate).getMonth() + 1)

watch(() => locale.value, (value) => {
  nextTick(() => {
    moment.locale(locale.value);
    initDatePicker();
  })
}, { deep: true })

function initDatePicker() {
  const button = document.getElementById(props.id)
  if(button) {
    button.addEventListener('click', (event) => {
      event.preventDefault();
    });
    button.click();
    const yearPicker = new tempusDominus.TempusDominus(button, {
      restrictions: {
        // maxDate: new Date()
      },
      display: {
        viewMode: "calendar",
        icons: {
          previous: "fa fa-angle-left fs-1",
          next: "fa fa-angle-right fs-1"
        },
        components: {
          decades: true,
          year: true,
          month: true,
          date: false,
          hours: false,
          minutes: false,
          seconds: false
        }
      },
      defaultDate: props.currentDate || date.value
    });
    yearPicker.setValue = props.currentDate
    yearPicker.subscribe(tempusDominus.Namespace.events.change, (e) => {
      const year = new Date(e.date).getFullYear()
      const month = new Date(e.date).getMonth() + 1
      if(new Date(props.currentDate).toDateString() !== new Date(e.date).toDateString()) {
        emits("update:date", { date: new Date(e.date), year, month: String(month).padStart(2, '0')})
      }
    })
  }
}

function getMonthLocalName(month, year, locale) {
  const date = new Date(year+"-"+month+"-"+"01")
  const options = { month: "long" };
  return new Intl.DateTimeFormat(locale, options).format(date)
}


onMounted(() => {
  nextTick(() => {
    moment.locale(locale.value);
    initDatePicker()
  })
})

</script>

<template>
  <button :id="id" type="button" class="btn btn-sm btn-flex btn-outline-primary fw-bolder shadow-sm border text-hover-white">
    <i class="fa fa-filter text-primary "></i>
    <span class="mx-4 text-capitalize"> {{ getMonthLocalName(parseInt(month), year, locale) }} {{ year }}</span>
    <i class="fa fa-angle-down text-primary fs-2"></i>
  </button>
</template>

<style>
.tempus-dominus-widget .toolbar {
  display: none !important;
}
</style>
